module.exports = __webpack_public_path__ + "static/img/default_img.814ce5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default_img.png
// module id = k6x5
// module chunks = 17